import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header, Content, PageSectionHeader } from '@/components';
import { Navbar } from './components';

const MediaPlan: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageSectionHeader>{t('mediaPlan')}</PageSectionHeader>
      <Navbar />
      <Content>
        <Outlet />
      </Content>
    </>
  );
};

export default MediaPlan;
